module.exports = __webpack_public_path__ + "static/media/subscription_icon.f470867d.svg";